import { RouteConfig } from 'vue-router';

export const loginRoute: RouteConfig = {
  path: '/login',
  name: 'login',
  component: () => import(/* webpackChunkName: "Login" */ '@/views/start/Login.vue')
};
